const map = {
	"./cin-node-logo.png": 96390,
	"./containers_schema.png": 1941,
	"./eu.png": 14513,
	"./inr-node-logo.png": 48733,
	"./jsc-node-logo.png": 85100,
	"./logo-bioexcel-cv19.png": 37376,
	"./logo-bioexcel.png": 26866,
	"./logo-bsc.png": 39165,
	"./logo-ebrains.png": 89639,
	"./logo-hbp.png": 96051,
	"./logo-irb.png": 92404,
	"./logo-mddb.png": 71088,
	"./logo-mdposit.png": 79637,
	"./logo-nostrum.png": 83153,
	"./oxf-node-logo.png": 3193,
	"./random_molecule.png": 583,
	"./rpbs-node-logo.png": 60123,
	"./ufl-node-logo.png": 84791
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65336;